<template>
  <ErrorPageTemplate>
    <template v-slot:content>
      <div class="page500">
        <div class="title mb-3">
          {{ $t('errorsPages.500.title') }}
        </div>
        <div
          class="description mb-5 text-left pl-5 pr-5"
          v-html="$t('errorsPages.5xx.description')"
        ></div>
        <div>
          <b-button
            :href="Links.socialLinks.facebook"
            class="px-4 rounded-xl text-md font-weight-bold line-height-lg"
            variant="primary"
          >
            {{ $t('errorsPages.5xx.buttonLabel') }}
          </b-button>
        </div>
      </div>
    </template>
  </ErrorPageTemplate>
</template>
<script>
import ErrorPageTemplate from '@/components/widgets/ErrorPageTemplate.vue'
import Links from '@/constants/links'

export default {
  name: 'InternalServerError',
  components: {
    ErrorPageTemplate
  },
  data() {
    return {
      Links
    }
  }
}
</script>
